import React from 'react';
// eslint-disable-next-line
import PropTypes from 'prop-types';
import { FormFeedback, Input } from 'reactstrap';

const Field = ({
  componentClass = Input,
  input,
  label,
  meta,
  help,
  valueAsChildren,
  render,
  passthrough,
  ...props
}) => {
  const { touched, error, dirty, active, visited, warning } = meta;
  const Component = componentClass;

  var componentProps;
  if (passthrough) {
    componentProps = {
      input,
      meta,
      ...props
    };
  } else {
    componentProps = {
      ...input,
      ...props
    };
  }

  const component = valueAsChildren ? (
    <Component {...componentProps}>{input.value}</Component>
  ) : (
    <Component invalid={!!(error || warning) && touched} {...componentProps} />
  );

  const flags = process.env.NODE_ENV === 'development' && (
    <div className="form-group-flags">
      {dirty && (
        <span className="field-dirty" title="Dirty">
          D
        </span>
      )}
      {active && (
        <span className="field-active" title="Active">
          A
        </span>
      )}
      {visited && (
        <span className="field-visited" title="Visited">
          V
        </span>
      )}
      {touched && (
        <span className="field-touched" title="Touched">
          T
        </span>
      )}
    </div>
  );

  const feedback = <FormFeedback>{error || warning}</FormFeedback>;

  return render ? (
    render({ component, feedback, flags, input, props })
  ) : (
    <React.Fragment>
      {component}
      {props.type !== 'hidden' && feedback}
      {props.type !== 'hidden' && flags}
    </React.Fragment>
  );
};

export default Field;



// WEBPACK FOOTER //
// ./src/components/form/field/field.js